<div class="price-row">
  <div
    class="price-discount-wrap"
    *ngIf="paymentCodeService.price$ | async as prices"
  >
    <ng-container *ngIf="prices.price === '0'">
      <div class="price-discount-cont">
        <span class="price">{{ getCurrencySymbol(prices.currency) }}{{ prices.price }}</span>
        <span class="discount">{{ 'priceUi.free' | translate }}</span>
      </div>
      <p class="original-price-wrapper">{{ 'priceUi.limitedTimeOffer' | translate }}</p>
    </ng-container>
    <ng-container *ngIf="prices.price !== '0'">

      <div class="price-discount-cont">
        <span class="price">{{ getCurrencySymbol(prices.currency) }}{{ prices.price }}</span>
        <span class="old-price">
          {{ 'priceUi.regularPrice' | translate }}
          <s>{{ getCurrencySymbol(prices.currency) }}{{ prices.oldPrice }}</s>
        </span>
      </div>

    </ng-container>
  </div>


</div>
